module.exports = __webpack_public_path__ + "img/CS_new_icons-weather.ba8fc629.png";